var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularVenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.4286L40 17L63 33.4286V37.9464H56.0465V63H23.9535V37.9464H17V33.4286Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5912 38.4252L43.2125 37.8829L40.6788 32.4895C40.5013 32.1119 39.9172 32.1119 39.7399 32.4895L37.2061 37.8829L30.8274 38.4252C30.3808 38.4631 30.2003 38.9724 30.5373 39.2437L35.35 43.1193L33.9415 48.8478C33.8429 49.2489 34.3155 49.5636 34.7011 49.3537L40.2093 46.3556L45.7175 49.3537C46.1032 49.5637 46.5757 49.2489 46.4771 48.8478L45.0686 43.1193L49.8814 39.2437C50.2183 38.9724 50.0378 38.4631 49.5912 38.4252Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6889 32.3039C34.0141 32.7179 34.9319 34.496 35.4567 35.5323C35.5392 35.6951 35.3162 35.8423 35.1738 35.7189C34.2683 34.934 32.7199 33.5721 32.3947 33.158C32.1374 32.8304 32.2185 32.3737 32.5759 32.1378C32.9333 31.9019 33.4316 31.9763 33.6889 32.3039Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7304 32.3039C46.4052 32.7179 45.4874 34.496 44.9626 35.5323C44.8801 35.6951 45.1031 35.8423 45.2455 35.7189C46.151 34.934 47.6994 33.572 48.0246 33.158C48.2819 32.8304 48.2008 32.3737 47.8434 32.1378C47.486 31.9019 46.9877 31.9763 46.7304 32.3039Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.869 44.445C51.3399 44.2868 49.213 44.0255 47.9766 43.8821C47.7822 43.8595 47.6971 44.099 47.8685 44.1858C48.9594 44.7382 50.8454 45.6766 51.3745 45.8348C51.7932 45.96 52.2432 45.7503 52.3798 45.3665C52.5163 44.9827 52.2877 44.5702 51.869 44.445Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5503 44.445C29.0794 44.2868 31.2063 44.0255 32.4427 43.8821C32.6371 43.8595 32.7222 44.099 32.5508 44.1858C31.4599 44.7382 29.5739 45.6766 29.0448 45.8348C28.6262 45.96 28.1761 45.7503 28.0395 45.3665C27.903 44.9827 28.1317 44.5702 28.5503 44.445Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4365 52.6941C39.4365 52.1839 39.825 50.2494 40.0596 49.1274C40.0965 48.951 40.3713 48.951 40.4081 49.1274C40.6428 50.2494 41.0313 52.1839 41.0313 52.6941C41.0313 53.0978 40.6743 53.425 40.2339 53.425C39.7935 53.4251 39.4365 53.0978 39.4365 52.6941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularVenue);
export default __webpack_public_path__ + "static/media/Popular_Venue.b69bc300d423e8fdc53127feab84c957.svg";
export { ForwardRef as ReactComponent };